import React from "react";
import { List, ListItem, useTheme } from "@mui/material";

import CartCard from "./CartCard";
import { getListItemStyles } from "./styles";

interface IProps {
  products: ICartProduct[];
  isCartPage: boolean;
  popUpHeight?: boolean;
  cartId?: string;
}

const CartList: React.FC<IProps> = ({ cartId,  popUpHeight, products, isCartPage }) => {
  const theme = useTheme();
  return (
    <List disablePadding sx={popUpHeight ? { maxHeight: '37vh', overflow: 'auto' } : {}}>
      {products.map((product) => (
        <ListItem
          disablePadding
          key={product.idProduct}
          sx={getListItemStyles(theme, isCartPage)}
        >
          <CartCard
              product={product}
              isCartPage={isCartPage}
              cartId={cartId}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default CartList;
